import { CustomImagesApi } from '../../api';
import axios from '../axios';

const customImagesApi = new CustomImagesApi(undefined, undefined, axios);

export default customImagesApi;
